module.exports = __webpack_public_path__ + "static/media/practice_image.fb8efd35.svg";